// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero_root__fV14S","title":"Hero_title__h28Ov","subTitle":"Hero_subTitle__R4apH","searchBar":"Hero_searchBar__Oyskf"};